<template>
    <home></home>
</template>

<script>
import home from '@/pages/home/index';
export default {
  components:{
    home
  }
}
</script>

<style lang="scss" src="./assets/scss/index.scss"></style>
